export default __webpack_public_path__ + "static/media/lets-go-king.7f7e99d2.jpeg";